import { ChangeDetectorRef, Directive, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[successData]',
})
export class SuccessDataDirective<T> {
  constructor(
    private readonly container: ViewContainerRef,
    private readonly template: TemplateRef<any>,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  public setData(data: T): void {
    this.container.clear();
    const ev = this.container.createEmbeddedView(this.template);
    ev.context.$implicit = data;
    this.cdr.detectChanges(); // mat-icons render text without this
  }
}
